import { Form, Input, Select } from 'antd';
import React, { ReactNode, useCallback } from 'react';

const { Option } = Select;

interface JSONTransformPathInputProps {
    isDetailMode: boolean | undefined;
    fieldName: string | number;
    pathValue: string | undefined;
    label?: string;
}

interface JSONTransformSelectProps {
    isDetailMode: boolean | undefined;
    fieldName: (string | number)[] | string | number;
    options: { value: string; label: string }[];
    value: string | undefined;
    label?: string;
    formatReadOnly?: (val: string) => ReactNode;
}

export const JSONTransformPathInput: React.FC<JSONTransformPathInputProps> = ({
    fieldName,
    isDetailMode,
    pathValue,
    label,
}) => {
    return (
        <Form.Item
            label={label}
            labelAlign="left"
            wrapperCol={{ span: 24 }}
            name={[fieldName, 'jsonTransformPath']}
            style={{ marginBottom: '0px' }}
        >
            {isDetailMode ? (
                <span>{`"${pathValue}"`}</span>
            ) : (
                <Input title='Path to apply this transform (e.g.: "/api/webhook" for the exact path for the webhook calls)' />
            )}
        </Form.Item>
    );
};

export const JSONTransformSelect: React.FC<JSONTransformSelectProps> = ({
    isDetailMode,
    value,
    options,
    fieldName,
    label,
    formatReadOnly,
}) => {
    const format = useCallback(
        (val: string | undefined) => {
            if (!val) return '-';
            if (formatReadOnly) return formatReadOnly(val);
            if (options) return options.find((o) => o.value === val)?.label || val;
            return val;
        },
        [formatReadOnly],
    );
    return (
        <Form.Item
            label={label}
            labelAlign="left"
            wrapperCol={{ span: 24 }}
            name={fieldName}
            style={{ marginBottom: '0px' }}
            initialValue={value}
        >
            {isDetailMode ? (
                <span className="text-capitalize">{format(value)}</span>
            ) : (
                <Select>
                    {options.map(({ label: optLab, value: val }) => (
                        <Option key={val} value={val}>
                            {optLab}
                        </Option>
                    ))}
                </Select>
            )}
        </Form.Item>
    );
};
